import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const FilterBar = ({ filters, onFilterChange, onReset }) => {
  const { t, currentLanguage } = useLanguage();

  const labels = {
    fr: {
      subscription: 'Type d\'abonnement',
      status: 'Statut',
      search: 'Rechercher une agence...',
      dateFrom: 'Date de début',
      dateTo: 'Date de fin',
      reset: 'Réinitialiser',
      apply: 'Appliquer'
    },
    ar: {
      subscription: 'نوع الاشتراك',
      status: 'الحالة',
      search: 'البحث عن وكالة...',
      dateFrom: 'تاريخ البداية',
      dateTo: 'تاريخ النهاية',
      reset: 'إعادة تعيين',
      apply: 'تطبيق'
    }
  };

  const subscriptionOptions = [
    { value: 'all', label: t('superAdmin.allPlans') },
    { value: 'basic', label: t('superAdmin.basicPlan') },
    { value: 'standard', label: t('superAdmin.standardPlan') },
    { value: 'premium', label: t('superAdmin.premiumPlan') },
    { value: 'trial', label: t('superAdmin.freeTrial') }
  ];

  const statusOptions = [
    { value: 'all', label: t('superAdmin.allStatuses') },
    { value: 'active', label: t('superAdmin.activeStatus') },
    { value: 'suspended', label: t('superAdmin.suspendedStatus') },
    { value: 'trial', label: t('superAdmin.trialStatus') }
  ];

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 md:p-6 mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-4">
        <div className="sm:col-span-2 lg:col-span-1">
          <Input
            type="search"
            placeholder={labels?.[currentLanguage]?.search}
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full"
          />
        </div>
        
        <Select
          options={subscriptionOptions}
          value={filters?.subscription}
          onChange={(value) => onFilterChange('subscription', value)}
          placeholder={labels?.[currentLanguage]?.subscription}
        />
        
        <Select
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          placeholder={labels?.[currentLanguage]?.status}
        />

        <div className="flex gap-2">
          <Button
            variant="outline"
            iconName="RotateCcw"
            onClick={onReset}
            fullWidth
            className="min-w-0"
          >
            <span className="hidden sm:inline">{labels?.[currentLanguage]?.reset}</span>
            <span className="sm:hidden">Reset</span>
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
        <Input
          type="date"
          label={labels?.[currentLanguage]?.dateFrom}
          value={filters?.dateFrom}
          onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
        />
        
        <Input
          type="date"
          label={labels?.[currentLanguage]?.dateTo}
          value={filters?.dateTo}
          onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
        />
      </div>
    </div>
  );
};

export default FilterBar;